// ----------------------------------------------------------------------
// <copyright file="Izenda.UserMenuActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { compose, withHandlers, withProps } from 'recompose';
import routeUtils from 'share/utils/Izenda.RouteUtils';
import AccountStore from 'logic/Izenda.AccountStore';
import uiState from 'logic/Izenda.UiState';
import { curry } from 'lodash/fp';

// Will mount
// - load current user by token

/**
 * Handle on click sign in.
 * @param  {Object} props
 * @param  {Object} obj
 */
const onClickSignOut = (props, obj) => {
  const signOutProcess = () => {
    const loginLink = routeUtils.getRouteUrl(routeUtils.getConfigRoute('Account', 'Login'));
    const loader = props.loader;

    loader.startLoading();
    return props.store
      .logout()
      .then(result => {
        if (result) {
          props.authorization.clear();
          props.router.push(loginLink);
        }

        return Promise.resolve(result);
      })
      .finally(loader.endLoading.bind(loader));
  };
  props.confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm }).then(signOutProcess);
};

const userMenuActions = compose(
  withProps(() => ({ store: new AccountStore() })),
  withHandlers({
    onClickSignOut: curry(onClickSignOut)
  })
);

export default userMenuActions;



// WEBPACK FOOTER //
// ./ui/share/components/layout/Izenda.UserMenuActions.js